// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"d1605a63","814":"572cf817"}[chunkId] + ".chunk.css";
};